import { Component } from '@angular/core';

@Component({
    selector: 'jhi-maj-site',
    templateUrl: './maj-site.component.html'
})
export class MajSiteComponent {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/maj-site/maj-site.component.ts